import { AfterContentInit, ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, Output, TemplateRef, ViewChild } from "@angular/core";
import { GrowlerKind } from "@spscommerce/ds-shared";

import { SpsGrowlerService } from "../../services/sps-growler.service";

@Component({
    selector: "sps-growler",
    templateUrl: "./sps-growler.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpsGrowlerComponent implements AfterContentInit, OnDestroy {
    static readonly displayName = "sps-growler";
    static readonly props = {
        title: "string",
        kind: "GrowlerKind",
        imgSrc: "string",
        close: { event: true, type: "void" },
    };

    @Input() title: string;
    @Input() kind: GrowlerKind = GrowlerKind.INFO;
    @Input() imgSrc: string;

    @Output() close = new EventEmitter<void>();

    @ViewChild("content", { static: false }) content: TemplateRef<any>;

    constructor(private _growlerService: SpsGrowlerService) {}

    ngAfterContentInit() {
        this._growlerService.createGrowler(this);
    }

    ngOnDestroy() {
        this._growlerService.removeGrowler(this);
    }

    onClose() {
        this.close.emit();
    }
}
